import React from "react";
import { INPUT_DOKTER, JADWAL_DOKTER, KUOTA_ONLINE_DOKTER, MM_BED, REK_MED, VERIFIKASI_BOOKING } from "App/constants";
import { ManajemenBed, ManajemenDokter, ManajemenJadwalDokter, ManajemenKuotaOnline, ProfileRekamMedis, VerifikasiBooking } from "../WrapperLazyExport";

export const menuManagement = {

  [MM_BED]: <ManajemenBed />,
  [INPUT_DOKTER]: <ManajemenDokter />,
  [JADWAL_DOKTER]: <ManajemenJadwalDokter />,
  [KUOTA_ONLINE_DOKTER]: <ManajemenKuotaOnline />,
  [VERIFIKASI_BOOKING]: <VerifikasiBooking />,
  [REK_MED]: <ProfileRekamMedis />,

};
